import React, { forwardRef } from "react";
import { DynamicLink } from "../DynamicLink/DynamicLink";
import styles from "./LinkButton.scss";
import classNames from "classnames";

interface ILinkButtonProps extends React.ComponentProps<typeof DynamicLink> {
  type?: "primary" | "secondary";
  fullWidth?: boolean;
  iconPrefix?: string;
  iconSuffix?: string;
}

export const LinkButton = forwardRef<HTMLAnchorElement, ILinkButtonProps>((props, ref) => {
  const { type = "primary", iconPrefix, iconSuffix, fullWidth, children, ...rest } = props;

  return (
    <DynamicLink
      {...rest}
      className={classNames(props.className, styles.button, {
        [styles.primary]: type === "primary",
        [styles.fullWidth]: fullWidth,
      })}
      ref={ref}
    >
      <div className={styles.inner}>
        {iconPrefix && <img src={iconPrefix} />}
        {children}
        {iconSuffix && <img src={iconSuffix} />}
      </div>
    </DynamicLink>
  );
});
